export default __webpack_public_path__ + "static/img-alert-c7a283beeafd1e7db6240e3adbbf9664.png";